__turbopack_context__.v({
  "bottomBar": "FooterSection-module__O-_nnW__bottomBar",
  "bottomLinks": "FooterSection-module__O-_nnW__bottomLinks",
  "btn": "FooterSection-module__O-_nnW__btn",
  "btnArrowIcon": "FooterSection-module__O-_nnW__btnArrowIcon",
  "copy": "FooterSection-module__O-_nnW__copy",
  "divider": "FooterSection-module__O-_nnW__divider",
  "earlyBtn": "FooterSection-module__O-_nnW__earlyBtn",
  "emailBox": "FooterSection-module__O-_nnW__emailBox",
  "emailIcon": "FooterSection-module__O-_nnW__emailIcon",
  "emailInput": "FooterSection-module__O-_nnW__emailInput",
  "footerHeading": "FooterSection-module__O-_nnW__footerHeading",
  "footerWrapper": "FooterSection-module__O-_nnW__footerWrapper",
  "formBox": "FooterSection-module__O-_nnW__formBox",
  "input": "FooterSection-module__O-_nnW__input",
  "inputWrapper": "FooterSection-module__O-_nnW__inputWrapper",
  "leftCol": "FooterSection-module__O-_nnW__leftCol",
  "leftColSpace": "FooterSection-module__O-_nnW__leftColSpace",
  "leftText": "FooterSection-module__O-_nnW__leftText",
  "list": "FooterSection-module__O-_nnW__list",
  "logoRow": "FooterSection-module__O-_nnW__logoRow",
  "more": "FooterSection-module__O-_nnW__more",
  "paymentRow": "FooterSection-module__O-_nnW__paymentRow",
  "socialBtn": "FooterSection-module__O-_nnW__socialBtn",
  "socialBtnActive": "FooterSection-module__O-_nnW__socialBtnActive",
  "socialGrid": "FooterSection-module__O-_nnW__socialGrid",
  "socialGridWrapper": "FooterSection-module__O-_nnW__socialGridWrapper",
  "socialIcon": "FooterSection-module__O-_nnW__socialIcon",
  "socialList": "FooterSection-module__O-_nnW__socialList",
  "topHeading": "FooterSection-module__O-_nnW__topHeading",
  "topText": "FooterSection-module__O-_nnW__topText",
});
